<template>
  <!-- 上传Excel -->
  <el-dialog
    :title="title"
    :visible.sync="visibleShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="40%"
  >
    <el-upload
      ref="upload"
      drag
      action=""
      multiple
      :limit="1"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="handleCrop"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传Excel文件</div>
    </el-upload>
    <div class="file_name" v-if="file.name">
      <p>{{ file.name }}</p>
      <i class="el-icon-close icon" title="删除文件" @click="file = {}"></i>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="close">取 消</el-button>
      <el-button
        size="mini"
        type="primary"
        :loading="updateLoading"
        :disabled="updateLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: "show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    url: String,
    title: String
  },
  data() {
    return {
      updateLoading: false,
      file: {},
      visibleShow: false
    };
  },
  watch: {
    show(val) {
      this.visibleShow = val;
    }
  },
  methods: {
    // 文件上传
    handleCrop(file) {
      this.$refs.upload.clearFiles();
      let file_name = file.name;
      let name_index = file_name.lastIndexOf(".");
      file_name = file_name
        .slice(name_index + 1, file_name.length)
        .toLowerCase();
      if (file_name == "xlsx" || file_name == "xls") {
        this.file = file.raw;
      } else {
        this.$hint("请上传Excel文件!", "err");
      }
    },
    // 确定导入
    submitForm() {
      if (JSON.stringify(this.file) == "{}") {
        this.$hint("请添加Excel文件!", "err");
        return;
      }
      this.updateLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.$http({
        url: this.url,
        data: formData,
        baseUrl: true
      }).then(res => {
        this.updateLoading = false;
        if (res.code == 0) {
          this.$emit("upLoadSuccess");
          this.$hint("添加成功");
          this.close();
        } else {
          this.$hint("添加失败", "err");
        }
      });
    },
    close() {
      this.file = {};
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="less" scoped>
.file_name {
  display: flex;
  align-items: center;
  margin-top: 10px;
  > p {
    font-size: 13px;
    color: #525f7f;
  }
  .icon {
    margin-left: 20px;
    transform: translateY(1px);
    color: #525f7f;
    &:hover {
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/components/upload.vue